<div class="content-card">
    <div fxLayout="row" fxLayoutAlign="center center" class="content">
        <div class="example-container">
            <!-- Panel akcji (dopasowany do wzorca) -->
            <div fxLayout="row" class="action-panel" [visibleWithPermissions]="['ManageEFolderOnWorkerProfile']">
                <button mat-raised-button color="primary" (click)="onAddClick()">
                    {{ 'ED-AddDocument' | translate }}
                </button>
            </div>

            <div class="table-wrapper custom-table">
                <mat-table #table matSort matSortActive="ValidFrom" matSortDirection="desc" matSortDisableClear
                    [dataSource]="dataSource$ | async">

                    <!-- Typ dokumentu -->
                    <ng-container matColumnDef="DocType">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                            {{ 'ED-DocType' | translate }}
                            <app-table-header-sort></app-table-header-sort>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let el">
                            <span>{{ el.docType }}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- Nazwa / Tytuł -->
                    <ng-container matColumnDef="Title">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                            {{ 'ED-Title' | translate }}
                            <app-table-header-sort></app-table-header-sort>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let el">
                            <a (click)="openPreview(el)">{{ el.title }}</a>
                        </mat-cell>
                    </ng-container>

                    <!-- Obowiązuje od -->
                    <ng-container matColumnDef="ValidFrom">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                            {{ 'ED-ValidFrom' | translate }}
                            <app-table-header-sort></app-table-header-sort>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let el">
                            {{ el.validFrom | date:'yyyy-MM-dd' }}
                        </mat-cell>
                    </ng-container>

                    <!-- Obowiązuje do -->
                    <ng-container matColumnDef="ValidTo">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                            {{ 'ED-ValidTo' | translate }}
                            <app-table-header-sort></app-table-header-sort>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let el">
                            {{ el.validTo | date:'yyyy-MM-dd' }}
                            @if (el.retentionNote) {
                            <mat-icon class="material-icons-outlined" [matTooltip]="el.retentionNote"
                                matTooltipClass="agreements-tooltip">info</mat-icon>
                            }
                        </mat-cell>
                    </ng-container>

                    <!-- Podpis / znacznik czasu -->
                    <ng-container matColumnDef="Signature">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="signatureStatus" class="hidden-sort">
                            {{ 'ED-Signature' | translate }}
                            <app-table-header-sort></app-table-header-sort>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let el">
                            <span>{{ el.signatureStatusName }}</span>
                            @if (el.signatureIssues?.length) {
                            <mat-icon class="material-icons-outlined" [matTooltip]="el.signatureIssues.join('\n')"
                                matTooltipClass="agreements-tooltip">warning</mat-icon>
                            }
                        </mat-cell>
                    </ng-container>

                    <!-- Wersja -->
                    <ng-container matColumnDef="Version">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                            {{ 'ED-Version' | translate }}
                            <app-table-header-sort></app-table-header-sort>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let el">
                            {{ el.version }}
                        </mat-cell>
                    </ng-container>

                    <!-- Dodano / Ostatnia zmiana -->
                    <ng-container matColumnDef="AddedBy">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                            {{ 'ED-AddedBy' | translate }}
                            <app-table-header-sort></app-table-header-sort>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let el">
                            {{ el.addedBy }} · {{ el.createdOn | date:'yyyy-MM-dd' }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="LastChanged">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                            {{ 'ED-LastChanged' | translate }}
                            <app-table-header-sort></app-table-header-sort>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let el">
                            {{ el.modifiedOn | date:'yyyy-MM-dd' }}
                        </mat-cell>
                    </ng-container>

                    <!-- Akcje -->
                    <ng-container matColumnDef="Actions" stickyEnd>
                        <mat-header-cell *matHeaderCellDef class="hidden-sort">
                            {{ 'WAD-Actions' | translate }}
                            <app-table-header-sort></app-table-header-sort>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let el">
                            <div fxLayout="row">
                                <mat-menu #docMenu="matMenu">
                                    <button mat-menu-item (click)="openPreview(el)">
                                        <mat-icon class="material-icons-outlined">find_in_page</mat-icon>
                                        {{ 'ED-Preview' | translate }}
                                    </button>
                                    <button mat-menu-item (click)="download(el)">
                                        <mat-icon class="material-icons-outlined">file_download</mat-icon>
                                        {{ 'ED-Download' | translate }}
                                    </button>
                                    <button mat-menu-item (click)="editMetadata(el)"
                                        [visibleWithPermissions]="['ManageEFolderOnWorkerProfile']">
                                        <mat-icon class="material-icons-outlined">edit</mat-icon>
                                        {{ 'ED-EditMetadata' | translate }}
                                    </button>
                                    <button mat-menu-item (click)="sign(el)"
                                        [visibleWithPermissions]="['ManageEFolderOnWorkerProfile']">
                                        <mat-icon class="material-icons-outlined">verified</mat-icon>
                                        {{ 'ED-SignOrTimestamp' | translate }}
                                    </button>
                                    <button mat-menu-item (click)="share(el)"
                                        [visibleWithPermissions]="['ManageEFolderOnWorkerProfile']">
                                        <mat-icon class="material-icons-outlined">share</mat-icon>
                                        {{ 'ED-Share' | translate }}
                                    </button>
                                </mat-menu>

                                <button mat-button class="button-text" [matMenuTriggerFor]="docMenu">
                                    <span>{{ 'Actions' | translate }}</span>
                                    <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                                </button>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns" (click)="rowClick(row)"></mat-row>
                </mat-table>
            </div>

            <mat-paginator [length]="total$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"
                (page)="onPage($event)">
            </mat-paginator>
        </div>
    </div>
</div>